export const RECEIVE_METER_BRANDS = 'RECEIVE_METER_BRANDS';
export const GET_METER_BRANDS = 'GET_METER_BRANDS';
export const SET_METER_BRAND = 'SET_METER_BRAND';
export const UPDATE_METER_BRAND = 'UPDATE_METER_BRAND';
export const DELETE_METER_BRAND = 'DELETE_METER_BRAND';
export const FETCH_METER_BRANDS = 'FETCH_METER_BRANDS';
